module.exports = __webpack_public_path__ + "static/media/customerServiceimg6.506811a9.png";